import React from 'react'
import { Card, Tooltip } from 'components/ui'
import { 
    HiStar, 
    HiSparkles
} from 'react-icons/hi'
import { BsLightning } from 'react-icons/bs'

const ModelCard = ({ model, isSelected, onSelect, tier }) => (
    <Card 
        className={`relative cursor-pointer transition-all duration-200 hover:shadow-lg border ${
            isSelected 
                ? 'border-purple-500 bg-purple-50 dark:bg-purple-900/20 shadow-lg border-2' 
                : 'border-gray-200 dark:border-gray-700 hover:border-purple-300 dark:hover:border-purple-600'
        }`}
        bodyClass="!py-3 !pb-3"
        onClick={() => onSelect(model.model)}
    >
        <div className="p-0">
            {/* Header with image and basic info */}
            <div className="flex items-center gap-3">
                <img 
                    src={model.image} 
                    alt={model.driverDisplayName}
                    className="w-6 h-6 flex-shrink-0"
                />
                <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                        <h6 className="font-semibold text-gray-900 dark:text-white truncate !text-sm">
                            {model.name}
                        </h6>
                        {model.best && (
                            <div className="flex items-center gap-1 px-2 py-0.5 bg-gradient-to-r from-yellow-50 to-orange-50 dark:from-yellow-900/20 dark:to-orange-900/20 rounded-full border border-yellow-200 dark:border-yellow-700/50">
                                <HiStar className="w-2 h-2 text-yellow-600 dark:text-yellow-400" />
                                <span className="text-[10px] text-yellow-700 dark:text-yellow-300 font-medium">Best</span>
                            </div>
                        )}
                        {model.new && (
                            <div className="flex items-center gap-1 px-2 py-0.5 bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 rounded-full border border-green-200 dark:border-green-700/50">
                                <HiSparkles className="w-2.5 h-2.5 text-green-600 dark:text-green-400" />
                                <span className="text-[10px] text-green-700 dark:text-green-300 font-medium">New</span>
                            </div>
                        )}
                    </div>
                    <div className='flex items-center gap-0.5 mt-0'>
                        <p className="text-xs text-gray-500 dark:text-gray-400">
                            {model.fullName || model.name}
                        </p>
                        {/* Price and credits */}
                        <div className="flex items-center gap-2">
                            <div className="flex items-center gap-1 text-gray-500 dark:text-gray-400">
                                -
                                <span className="text-xs font-medium">{model.price} credits</span>
                            </div>
                        </div>
                    </div>

                    {/* Available sizes */}
                    {/* <div className="flex items-center gap-1">
                        <span className="text-xs text-gray-500 dark:text-gray-400">Sizes:</span>
                        <div className="flex gap-1">
                            {model.availableSizes?.map(size => (
                                <span key={size} className="text-[10px] px-1.5 py-0.5 bg-gray-100 dark:bg-gray-800 rounded text-gray-600 dark:text-gray-300">
                                    {size}
                                </span>
                            ))}
                        </div>
                    </div> */}
                </div>
            </div>

            {/* Selection indicator */}
            {isSelected && (
                <div className="absolute top-4 right-4">
                    <div className="w-4 h-4 bg-purple-500 rounded-full flex items-center justify-center">
                        <div className="w-2 h-2 bg-white rounded-full"></div>
                    </div>
                </div>
            )}
        </div>
    </Card>
)

export default ModelCard
